<template>
  <div class="downLoad">
    <img src="@/assets/img/download/1.png" alt="" class="w_img" />
    <div class="android">
      <img src="@/assets/img/download/android.png" alt="" class="down_btn" @click="dowsAndroid" />
    </div>
    <div>
      <img src="@/assets/img/download/ios.png" alt="" class="down_btn" @click="dowsIos" />
    </div>
    <div class="address">官网地址: {{ initInfo.siteDomain }}</div>
    <a class="_a" @click="moBtn"
      >点击查看安装教程
      <img src="@/assets/img/download/download.png" alt="" class="w_img" />
    </a>
    <div class="swipe_box">
      <van-swipe class="my-swiper" indicator-color="#D8AD6D" :autoplay="3000">
        <van-swipe-item>
          <div class="b_title">各大高清赛事直播</div>
          <div class="s_title">未来心仪比赛可预约观看</div>
          <img src="@/assets/img/download/2.png" alt="" />
        </van-swipe-item>
        <van-swipe-item>
          <div class="b_title">专业&颜值主播解说</div>
          <div class="s_title">专业&一起激情观看体育赛事</div>
          <img src="@/assets/img/download/3.png" alt="" />
        </van-swipe-item>
        <van-swipe-item>
          <div class="b_title">精准赛事分析</div>
          <div class="s_title">有料专家专业解读</div>
          <img src="@/assets/img/download/4.png" alt="" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <a ref="mao" class="mao">
      <img src="@/assets/img/download/5.png" alt="" class="mao_img" />
    </a>
    <div class="email">客服邮箱：{{ initInfo.serviceEmail}}</div>
    <div class="copyright">虎鲸直播 版权所有 © 2023, All rights reserved.</div>
  </div>
</template>
<script setup name="DownLoad">
import { getInit } from "@/assets/api/home";
import { onMounted, ref } from "vue";
const mao = ref();
function moBtn() {
  mao.value.scrollIntoView({ behavior: "smooth" });
}
const initInfo = ref({});
function _getInit() {
  getInit().then((res) => {
    initInfo.value = res.data;
  });
}
function dowsAndroid() {
  window.location.href = initInfo.value.dlAndroid;
}
function dowsIos() {
  window.location.href = initInfo.value.dlIos;
}
onMounted(() => {
  _getInit();
});
</script>

<style scoped>
.downLoad {
  background: #e2e8f0;
  padding-bottom: 26.93vw;
  overflow-y: scroll;
}

.w_img {
  width: 100%;
  height: auto;
}
.mao_img {
  width: 92%;
  height: auto;
}
._a {
  color: #de972b;
  text-align: center;
  font-family: PingFang SC;
  font-size: 4.26vw;
  font-weight: 400;
  line-height: 5.86vw;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 6.66vw;
}
._a img {
  width: 3.2vw;
  height: 3.2vw;
  margin-left: 1.6vw;
}

.down_btn {
  width: 44.8vw;
}
.android {
  margin: 8vw 0 3.73vw;
}
.address {
  color: #475569;
  text-align: center;
  font-family: PingFang SC;
  font-size: 4.26vw;
  font-style: normal;
  font-weight: 400;
  line-height: 5.86vw;
  margin-top: 8vw;
}
.email {
  color: #4b5563;
  text-align: center;
  font-family: PingFang SC;
  font-size: 3.73vw;
  font-weight: 400;
  line-height: 5.3vw;
  margin-top: 5.86vw;
}
.copyright {
  color: #9ca3af;
  text-align: center;
  margin: 2.66vw 0 0;
  font-family: PingFang SC;
  font-size: 3.73vw;
  font-weight: 400;
  line-height: 5.3vw;
}
.swipe_box {
  margin: 10.66vw 0 14.13vw;
  height: 141.86vw;
}
.swipe_box img {
  width: 56.53vw;
  height: auto;
}

.b_title {
  color: #de972b;
  text-align: center;
  font-family: PingFang SC;
  font-size: 5.3vw;
  font-weight: 600;
  line-height: 5.86vw;
  margin-bottom: 4px;
  margin-top: 5.3vw;
}
.s_title {
  color: #6b7280;
  text-align: center;
  font-family: PingFang SC;
  font-size: 3.46vw;
  font-weight: 400;
  line-height: 5.86vw;
  margin-bottom: 6.4vw;
}
</style>
<style>
.my-swiper .van-swipe__indicator {
  width: 6.4vw !important;
  height: 4px !important;
  border-radius: 2px;
  background: #cbd5e1;
}
.my-swiper .van-swipe__indicators {
  top: 0;
  height: 4px;
}
.downLoad::-webkit-scrollbar {
  display: none;
}
</style>
